import React from 'react'
import { IIconProps } from 'submodules/nerit-framework-ui/common/components/icon/inner/IIconProps'
import { IconICP } from 'submodules/nerit-framework-ui/common/components/icon/inner/IconICP'

export function LoadingIconCP(props: IIconProps): JSX.Element {
    return <IconICP iconName={'loading'} {...props}/>
}
